/* eslint-disable @typescript-eslint/no-redeclare */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Step from '../../../components/Step/Step';
import { useNavigate } from 'react-router-dom';
import './style.css';
import assets from '../../../assets';
import { formatDinheiro } from '../../../utils/formatDinheiro';
import { useApi } from 'hooks/userApi';
import { LoadingContext } from 'context/Loading/LoadingContext';
import { format } from 'date-fns';
import { CarrinhoContext } from 'context/Carrinho/CarrinhoContext';

const api = useApi();

const Title = ({ title }) => {
  return (
    <div className="search">
      <div className="title">{title}</div>
    </div>
  );
};

const DetalhesClienteReview = ({ dadosCheckout, vendedor }) => {
  return (
    <Box className="white-bg" style={{ display: 'flex', flexDirection: 'column' }}>
      <p className="titulos">Detalhes do pedido</p>
      <span>
        <b>Nome:</b> {dadosCheckout.nome}
      </span>
      <span>
        <b>E-mail:</b> {dadosCheckout.email}
      </span>
      <span>
        <b>Telefone:</b> {dadosCheckout.telefone}
      </span>
      <hr className="hr-line" />
      {dadosCheckout.observacoes && (
        <div>
          <p className="titulos">Observações</p>
          <div className="obsReview">{dadosCheckout.observacoes}</div>
        </div>
      )}
      <hr className="hr-line" />
      <p className="titulos" style={{ marginBottom: 16 }}>
        Dados do revendedor
      </p>
      <span>
        <b>Nome:</b> {vendedor.nome}
      </span>
      <span>
        <b>E-mail:</b> {vendedor.email}
      </span>
      <span>
        <b>Contato:</b> {vendedor.contato}
      </span>
    </Box>
  );
};

const DetalhesCompraReview = ({ dadosCheckout }) => {
  let valorIpi;
  let valorTotal;
  let valorProdutos;
  const navigate = useNavigate();
  const { loading, setLoading, setLoadingMensagem, setLoadingBtn, setLoadingAction, setClearLoading }: any =
    useContext(LoadingContext);

  dadosCheckout.produtos.forEach((produto) => {
    valorIpi = produto.valorIPI;
    valorTotal = produto.valorTotal;
    valorProdutos = produto.valor;
  });

  const handclick = () => {
    const orcamento = {
      validade: dadosCheckout.validade,
      frete: dadosCheckout.freteFixo,
      precoFinal: dadosCheckout.precoFinal,
      status: 'feito',
      arquivo: dadosCheckout.arquivo,
      nome: '?',
      prazoEntrega: dadosCheckout.validade,
      cliente: dadosCheckout.clienteId,
      pagamento: dadosCheckout.pagamento,
      vendedor: dadosCheckout.vendedor,
      negociacao: dadosCheckout.negociacao,
      descontoFrete: dadosCheckout.descontoFrete,
      despesas: dadosCheckout.despesas,
      observacoes: dadosCheckout.observacoes,
      embarque: dadosCheckout.embarque,
      tipofrete: dadosCheckout.tipoFrete,
    };
    const relacionaOrcamento = async (produtoOrcamento) => {
      setLoading(true);
      return new Promise(async (resolve, reject) => {
        const o = await api.post('/orcamento-produto', produtoOrcamento);
        if (o.status) {
          setClearLoading(true);
          return resolve(o.mensagem);
        }
        const msg = 'OPS, Desculpe não foi possível gerar orçamento. ';
        setLoadingMensagem(msg);
        setLoadingBtn('OK');
      }).catch((e) => {
        const msg = 'Houve um erro interno, tente mais tarde. ' + e.message;
        setLoadingMensagem(msg);
        setLoadingBtn('OK');
      });
    };

    const criaOrcamento = (orcamento) => {
      return new Promise(async (resolve, reject) => {
        const o = await api.post('/orcamento', orcamento);
        if (o.status) {
          return resolve(o.mensagem);
        }
        console.log('retorno', o);
        const msg = 'OPS, Desculpe não foi possível gerar o orçamento. ';
      }).catch((e) => {
        const msg = 'Houve um erro interno, tente mais tarde. ' + e.message;
      });
    };

    criaOrcamento(orcamento).then(async (resp) => {
      Promise.all(
        dadosCheckout.produtoCar.map((p) => {
          p.orcamento = resp;
          delete p.created_at;
          delete p.id;
          delete p.produtoId;
          delete p.orcamentoId;
          delete p.updated_at;
          delete p.deleted_at;
          p.valor = Number(p.valor);
          p.ipi = Number(p.produto.ipi);
          return relacionaOrcamento(p);
        }),
      )
        .then((responses) => {
          navigate('/vendedor/checkoutPDF/' + responses[0].orcamentoId);
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
          console.log(error.config);
        });
    });
  };

  return (
    <Box className="white-bg">
      <p className="titulos">Valor total da compra</p>
      <hr className="hr-line" />
      <div className="flex-space-between">
        <label>Produtos ({dadosCheckout.produtos.length}) </label>
        <div>{formatDinheiro(valorProdutos, 2)}</div>
      </div>
      <div className="flex-space-between">
        <label>Frete</label>
        <div>{formatDinheiro(dadosCheckout.freteFixo, 2)}</div>
      </div>
      <div className="flex-space-between">
        <label>Despesas</label>
        <div>{formatDinheiro(dadosCheckout.despesas, 2)}</div>
      </div>
      <div className="flex-space-between">
        <label>Desconto</label>
        <div>{formatDinheiro(dadosCheckout.descontoFrete, 2)}</div>
      </div>
      <div className="flex-space-between">
        <label>Valor do IPI total</label>
        <div>{formatDinheiro(valorIpi, 2)}</div>
      </div>
      <div className="flex-space-between">
        <label>Valor total</label>
        <div>{formatDinheiro(valorTotal, 2)}</div>
      </div>
      <button className="btn-v-checkout" onClick={handclick}>
        {' '}
        CONFIRMAR E GERAR ORÇAMENTO{' '}
      </button>
    </Box>
  );
};

const DetalhesProdutosReview = ({ dadosCheckout }) => {
  return (
    <Box className="white-bg">
      <p className="titulos">Produtos</p>
      <hr className="hr-line" />
      <List
        sx={{
          width: '100%',
          maxWidth: '100%',
          maxHeight: 600,
          overflowY: 'auto',
        }}
      >
        {dadosCheckout.produtos.map((p, index) => (
          <ListItem
            sx={{
              borderBottom: 1,
              borderColor: '#E0E0E0',
              flexDirection: 'column',
              alignItems: 'flex-start',
              padding: 0,
            }}
            key={index}
          >
            <div style={{ display: 'flex', width: '100%', marginBottom: '16px' }}>
              <ListItemAvatar>
                <Avatar variant="square" sx={{ width: 96, height: 96, borderRadius: '8px' }}>
                  {p.produto.caracteristicas[0]?.fotos[0]?.imagem ? (
                    <img
                      className="imagem-produto"
                      src={p.produto.caracteristicas[0]?.fotos[0]?.imagem}
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                  ) : (
                    <img
                      className="imagem-produto"
                      src={assets.images.produto}
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                  )}
                </Avatar>
                <Typography className="product-sku">SKU: {p.produto.SKU} </Typography>
              </ListItemAvatar>
              <div style={{ flex: 1, marginLeft: '20px' }}>
                <Typography
                  style={{
                    color: '#136033',
                    fontWeight: 600,
                    fontSize: '20px',
                    marginBottom: '16px',
                  }}
                >
                  {p.produto.nome}
                </Typography>
                <div
                  style={{
                    display: 'flex',
                    fontSize: '14px',
                    justifyContent: 'space-between',
                  }}
                >
                  <div>
                    <div>Qtde.</div>
                    <div>{p.quantidade}</div>
                  </div>
                  <div>
                    <div>Vlr. Unitário</div>
                    <div>{formatDinheiro(p.valorUn, 2)}</div>
                  </div>
                  <div>
                    <div>Frete</div>
                    <div>{formatDinheiro(p.valorFrete)}</div>
                  </div>
                  <div>
                    <div>IPI</div>
                    <div>{p.produto.ipi}%</div>
                  </div>
                  <div>
                    <div>Vlr. IPI</div>
                    <div>{formatDinheiro(p.valorIPI)}</div>
                  </div>
                  <div>
                    <div>Vlr. Total</div>
                    <div>{formatDinheiro(p.valor)}</div>
                  </div>
                </div>
              </div>
            </div>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

const DetalhesPagamento = ({ dadosCheckout }) => {
  return (
    <Box className="white-bg">
      <p>
        Método de pagamento: <b>{dadosCheckout.pagamentoNome}</b>
      </p>
      <p>
        Frete: <b>{dadosCheckout.tipoFrete}</b>
      </p>
      <p>
        Prazo de embarque: <b>{format(dadosCheckout.embarque, 'dd-MM-yyyy')}</b>
      </p>
      <p>
        Validade da proposta: <b>{format(dadosCheckout.validade, 'dd-MM-yyyy')}</b>
      </p>
    </Box>
  );
};

const CheckoutReview = () => {
  const items = [
    ['Orçamento', true],
    ['Checkout', true],
    ['Confirmação', true],
    ['PDF', false],
  ];

  const dadosCheckout = JSON.parse(sessionStorage.getItem('checkoutData'));

  const [vendedor, setVendedor] = useState(JSON.parse(sessionStorage.getItem('user')));
  const api = useApi();

  const carregaVendedorAtualizado = async () => {
    if (vendedor && vendedor.id) {
      try {
        const response = await api.get(`/vendedor/${vendedor.id}`);
        if (response.status) {
          setVendedor(response.mensagem);
          sessionStorage.setItem('user', JSON.stringify(response.mensagem));
        }
      } catch (e) {
        console.error('Erro ao carregar dados atualizados do vendedor:', e);
      }
    }
  };

  useEffect(() => {
    carregaVendedorAtualizado();
  }, []);

  return (
    <div className="container">
      <div
        style={{
          display: 'flex',
          borderRadius: '0px 0px 48px 48px',
          backgroundImage: `linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.2) 100%), url(${assets.images.bgCheckout})`,
          backgroundColor: '#136033',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundBlendMode: 'multiply, screen, normal',
          padding: ' 32px 200px',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Title title="Confirmação" />
        <Step items={items} />
      </div>
      <Box>
        <Box
          style={{
            display: 'flex',
            gap: '75px',
            justifyContent: 'center',
            flexWrap: 'wrap',
          }}
        >
          <Box width={'40%'}>
            <DetalhesClienteReview dadosCheckout={dadosCheckout} vendedor={vendedor} />
          </Box>
          <div style={{ width: '50%' }}>
            <Box>
              <DetalhesProdutosReview dadosCheckout={dadosCheckout} />
            </Box>
            <Box>
              {<DetalhesCompraReview dadosCheckout={dadosCheckout} />}
              {<DetalhesPagamento dadosCheckout={dadosCheckout} />}
              <div>{/* <button onClick={handleEditClick}> VOLTAR E EDITAR </button> */}</div>
            </Box>
          </div>
        </Box>
      </Box>
    </div>
  );
};

export default CheckoutReview;
